import { compose, branch, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import { selectModalMethod } from 'src/store/selectors/affordability'
import { selectLoading, selectFirstPrequal } from 'src/store/selectors/prequal'
import { PREQUAL } from 'src/constants/affordability'
import LoadingBlock from 'src/Components/shared/Loading/LoadingBlock'

const PrequalContainer = compose(
  connect(state => ({
    loading: selectLoading(state),
    show: selectModalMethod(state) === PREQUAL,
    hasPrequal: Boolean(selectFirstPrequal(state))
  })),
  branch(({ loading }) => loading, () => LoadingBlock),
  branch(({ show }) => !show, renderNothing)
)

export default PrequalContainer
